export const DASHBOARD_RANGES = [
    { key: '24h', label: '24 ГОД' },
    { key: '7d', label: '7 ДНІВ' },
    { key: '30d', label: '30 ДНІВ' },
];
// Кожна котра мітка на осі X: 24 години — кожна 6-та, 7 днів — кожен, 30 днів — кожен 5-й.
export const X_LABEL_EVERY = { '24h': 6, '7d': 1, '30d': 5 };
const TICK_COUNT = 4;
// Вісь Y з чотирма рівними інтервалами «круглого» кроку (1, 2, 5 × 10ⁿ), щоб підписи
// були цілими, а верх графіка — не нижчий за найбільше значення.
export function niceAxis(max) {
    const raw = Math.max(max, 1) / TICK_COUNT;
    const magnitude = 10 ** Math.floor(Math.log10(raw));
    const step = [1, 2, 5, 10].map((m) => m * magnitude).find((candidate) => candidate >= raw) ?? 10 * magnitude;
    const intStep = Math.max(1, Math.ceil(step));
    return {
        max: intStep * TICK_COUNT,
        ticks: Array.from({ length: TICK_COUNT + 1 }, (_, i) => i * intStep),
    };
}
export function bucketLabel(start) {
    if (start.includes('T'))
        return `${start.slice(11, 13)}:00`;
    return `${start.slice(8, 10)}.${start.slice(5, 7)}`;
}
